import { apiClient } from './apiClient';
import { Document } from '../slices/documentsSlice';

export const documentsApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    getDocuments: builder.query<Document[], { siteId?: string } | void>({
      query: (params) => {
        const queryParams = params?.siteId ? `?site_id=${params.siteId}` : '';
        return {
          url: `/api/v1/documents/${queryParams}`,
          method: 'GET',
        };
      },
    }),
    deleteDocument: builder.mutation<void, string>({
      query: (documentId) => ({
        url: `/api/v1/documents/${documentId}`,
        method: 'DELETE',
      }),
    }),
    uploadDocument: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: '/api/v1/documents/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    downloadDocument: builder.query<Blob, string>({
      query: (documentId) => ({
        url: `/api/v1/documents/${documentId}/download`,
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    downloadArtefact: builder.mutation<
      { url: string; filename: string; expires_in: number; expires_at: string },
      { artefact_id: string; document_id: string; tenant_id: string; filename: string; expires_in?: number }
    >({
      query: ({ artefact_id, document_id, tenant_id, filename, expires_in = 3600 }) => ({
        url: `/api/v1/artefacts/${artefact_id}/download`,
        method: 'POST',
        body: {
          document_id,
          tenant_id,
          filename,
          expires_in,
        },
      }),
    }),
    exportDocumentExcel: builder.query<Blob, string>({
      query: (documentId) => ({
        url: `/api/v1/documents/${documentId}/export-excel`,
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    bulkExportExcel: builder.query<Blob, void>({
      query: () => ({
        url: '/api/v1/documents/bulk-export-excel',
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetDocumentsQuery,
  useDeleteDocumentMutation,
  useUploadDocumentMutation,
  useLazyDownloadDocumentQuery,
  useDownloadArtefactMutation,
  useLazyExportDocumentExcelQuery,
  useLazyBulkExportExcelQuery,
} = documentsApi;

